var React = require('react');

function EtteMobileMenu3 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M0,3.5c5.2-0.1,8,0.3,13.1-1c2.3-0.4,6.9,0,9.3,0.3c1.5,0.2,3,0.1,4.4-0.1c0.5,0,1.3,0.2,1.7-1.2\n\tc-2.2,0-4.3-0.3-6.4-0.3C19.2,1.3,16.4,0,13.5,0C5.6,0.1,3.1,1.8,0,3.5"}));
}

EtteMobileMenu3.defaultProps = {"x":"0px","y":"0px","viewBox":"0 0 28.5 3.5"};

module.exports = EtteMobileMenu3;

EtteMobileMenu3.default = EtteMobileMenu3;
